import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import { CurrencyEnum } from 'app/components/ui/CurrencySwitcher/CurrencySwitcher';

export const CurrencyContext = createContext<any>({
  currency: CurrencyEnum.XTZ,
  xtzUsdQuote: 0,
});

export const useCurrency = () => useContext(CurrencyContext);

export const CurrencyProvider: React.FC = ({ children }) => {
  const currencyFromLS: CurrencyEnum = localStorage.getItem('currency') as CurrencyEnum;

  const [currency, setCurrency] = useState<CurrencyEnum>(currencyFromLS || CurrencyEnum.XTZ);
  const [xtzUsdQuote, setXtzUsdQuote] = useState<number>(0);

  useEffect(() => {
    localStorage.setItem('currency', currency);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{
      currency, setCurrency, xtzUsdQuote, setXtzUsdQuote,
    }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
